// // import React, { useState, useRef } from 'react';
// // import { MDBFooter, MDBContainer, MDBCol, MDBRow } from 'mdb-react-ui-kit';
// // import Form from 'react-bootstrap/Form';
// // import Col from 'react-bootstrap/Col';
// // import InputGroup from 'react-bootstrap/InputGroup';
// // import Button from 'react-bootstrap/Button';
// // import emailjs from 'emailjs-com';
// // import ReCAPTCHA from "react-google-recaptcha";

// // export const Contact = () => {
// //   const [formData, setFormData] = useState({
// //     first_name: '',
// //     email_id: '',
// //     message: '',
// //   });

// //   const [recaptchaValue, setRecaptchaValue] = useState(null);
// //   const recaptchaRef = useRef(null);

// //   const handleChange = (e) => {
// //     const { name, value } = e.target;
// //     setFormData((prevFormData) => ({
// //       ...prevFormData,
// //       [name]: value,
// //     }));
// //   };

// //   const handleRecaptchaChange = (value) => {
// //     setRecaptchaValue(value);
// //   };

// //   const handleSubmit = (e) => {
// //     e.preventDefault();

// //     if (!recaptchaValue) {
// //       console.error('Please complete the reCAPTCHA.');
// //       return;
// //     }

// //     // Your EmailJS configuration
// //     const serviceId = 'service_up7eara';
// //     const templateId = 'template_r446xxq';
// //     const userId = '4S9SBuGXNl2oJO-Xa';

// //     // Send the email using EmailJS
// //     emailjs.send(serviceId, templateId, formData, userId)
// //       .then((response) => {
// //         console.log('Email sent successfully:', response);
// //         // Reset the form after successful submission
// //         setFormData({
// //           first_name: '',
// //           email_id: '',
// //           message: '',
// //         });
// //         setRecaptchaValue(null);
// //         recaptchaRef.current.reset();
// //       })
// //       .catch((error) => {
// //         console.error('Error sending email:', error);
// //       });
// //   };

// //   return (
// //     <div className='contact' id="Contact">

// //         <div className='Contact-container'>
// //       <div>
// //         <h1 className='contact-title'>CONTACT US</h1>
// //         <div className='contact-txt'>
// //         <p>Please don't hesitate to send us a message if you have any questions. We are here to help and would be delighted to assist you with any inquiries you may have.</p>
// //         </div>
// //       </div>
// //       <div className="footer" id="contacto">
// //         <MDBFooter className='text-body text-center text-lg-left '>
// //           <MDBContainer className='p-4' style={{ maxWidth: '700px' }}>
// //             <MDBRow>
// //               <MDBCol lg='5' md='12' className='mb-4 mb-md-0' id="infoFooter">
// //                 <div className="infocourseFooter" id="infoFooterTitulo2"></div>
// //                 <div className='contactInfo'>
// //                   {/* <div className='logo-footer'>
// //                     <img className='logoFooter' src="/img/sekemWhite.png" alt="Logo" style={{ width: '170px' }} />
// //                   </div> */}
// //                   <div className='info-email'>
// //                     <h4 style={{ marginBottom: '0.3rem' }}>Email to us</h4>
// //                     <h6 style={{ marginBottom: '0.2rem' }}>info@kranestation.co.nz</h6>
// //                   </div>
// //                 </div>
// //               </MDBCol>

// //               <MDBCol lg='7' md='12' className='mb-4 mb-md-0'>
// //                 <div className='registerForm'>
// //                   <div className='formApply'>
// //                     <Form onSubmit={handleSubmit}>
// //                       <Form.Group className="mb-4" as={Col} controlId="validationCustom01">
// //                         <Form.Control
// //                           required
// //                           type="text"
// //                           placeholder="Name"
// //                           feedback="Please write your first name."
// //                           name="first_name"
// //                           value={formData.first_name}
// //                           onChange={handleChange}
// //                         />
// //                         <Form.Control.Feedback type="invalid">
// //                           Please write your name
// //                         </Form.Control.Feedback>
// //                         <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
// //                       </Form.Group>

// //                       <Form.Group className="mb-4" as={Col} controlId="validationCustomUsername">
// //                         <InputGroup hasValidation>
// //                           <InputGroup.Text id="inputGroupPrepend">@</InputGroup.Text>
// //                           <Form.Control
// //                             type="email"
// //                             placeholder="Email"
// //                             aria-describedby="inputGroupPrepend"
// //                             required
// //                             name="email_id"
// //                             value={formData.email_id}
// //                             onChange={handleChange}
// //                           />
// //                           <Form.Control.Feedback type="invalid">
// //                             Please choose an email.
// //                           </Form.Control.Feedback>
// //                         </InputGroup>
// //                       </Form.Group>

// //                       <Form.Group className="mb-4" as={Col} controlId="message">
// //                         <InputGroup hasValidation>
// //                           <Form.Control
// //                             as="textarea"
// //                             rows={3}
// //                             type="text"
// //                             placeholder="Message"
// //                             aria-describedby="inputGroupPrepend"
// //                             name="message"
// //                             required
// //                             value={formData.message}
// //                             onChange={handleChange}
// //                           />
// //                           <Form.Control.Feedback type="invalid">
// //                             Please write a message.
// //                           </Form.Control.Feedback>
// //                         </InputGroup>
// //                       </Form.Group>

// //                       <Form.Group className="mb-3 d-flex justify-content-end" controlId="checkBox1" style={{ color: "white" }}>
// //                         {/* Recapcha for localhost */}
// //                         {/* <ReCAPTCHA sitekey='6Le0MU8oAAAAAM4zQ8AMbN6ylaqWJP8w-3MwrqMA' onChange={handleRecaptchaChange} /> */}
// //                         {/* Recapcha for  kranestation.co.nz*/}
// //                         <ReCAPTCHA sitekey='6LdT26woAAAAABg64esaHXXxC8E2BoRtrhl_0mOV' onChange={handleRecaptchaChange} />
                        
// //                       </Form.Group>

// //                       <div className='btnForm' style={{ display: 'flex', justifyContent: 'flex-end' }}>
// //                         <Button id="btn" type="submit">Send</Button>
// //                       </div>
// //                     </Form>
// //                   </div>
// //                 </div>
// //               </MDBCol>
// //             </MDBRow>
// //           </MDBContainer>
// //         </MDBFooter>
// //       </div>
// //       </div>
// //     </div>
    
// //   );
// // };
// // export default Contact;




// import React, { useState, useRef } from 'react';
// import { MDBFooter, MDBContainer, MDBCol, MDBRow } from 'mdb-react-ui-kit';
// import Form from 'react-bootstrap/Form';
// import Col from 'react-bootstrap/Col';
// import InputGroup from 'react-bootstrap/InputGroup';
// import Button from 'react-bootstrap/Button';
// import emailjs from 'emailjs-com';
// import ReCAPTCHA from "react-google-recaptcha";

// export const Contact = () => {
//   const [formData, setFormData] = useState({
//     first_name: '',
//     email_id: '',
//     message: '',
//   });

//   const [validated, setValidated] = useState(false);
//   const [showSuccess, setShowSuccess] = useState(false);
//   const [recaptchaValue, setRecaptchaValue] = useState(null);
//   const recaptchaRef = useRef(null);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevFormData) => ({
//       ...prevFormData,
//       [name]: value,
//     }));
//   };

//   const handleRecaptchaChange = (value) => {
//     setRecaptchaValue(value);
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const form = e.currentTarget;

//     if (form.checkValidity() === false || !recaptchaValue) {
//       e.stopPropagation();
//       setValidated(true);
//       return;
//     }

//     setValidated(true);

//     const serviceId = 'service_up7eara';
//     const templateId = 'template_r446xxq';
//     const userId = '4S9SBuGXNl2oJO-Xa';

//     emailjs.send(serviceId, templateId, formData, userId)
//       .then((response) => {
//         console.log('Email sent successfully:', response);

//         // Mostrar cartel de confirmación
//         setShowSuccess(true);

//         // Resetear el formulario y recaptcha
//         setFormData({
//           first_name: '',
//           email_id: '',
//           message: '',
//         });
//         setRecaptchaValue(null);
//         recaptchaRef.current.reset();

//         // Ocultar mensaje después de unos segundos
//         setTimeout(() => setShowSuccess(false), 5000);
//       })
//       .catch((error) => {
//         console.error('Error sending email:', error);
//       });
//   };

//   return (
//     <div className='contact' id="Contact">
//       <div className='Contact-container'>
//         <div>
//           <h1 className='contact-title'>CONTACT US</h1>
//           <div className='contact-txt'>
//             <p>Please don't hesitate to send us a message if you have any questions. We are here to help and would be delighted to assist you with any inquiries you may have.</p>
//           </div>
//         </div>

//         <div className="footer" id="contacto">
//           <MDBFooter className='text-body text-center text-lg-left'>
//             <MDBContainer className='p-4' style={{ maxWidth: '700px' }}>
//               <MDBRow>
//                 <MDBCol lg='5' md='12' className='mb-4 mb-md-0' id="infoFooter">
//                   <div className='contactInfo'>
//                     <div className='info-email'>
//                       <h4 style={{ marginBottom: '0.3rem' }}>Email to us</h4>
//                       <h6 style={{ marginBottom: '0.2rem' }}>info@kranestation.co.nz</h6>
//                     </div>
//                   </div>
//                 </MDBCol>

//                 <MDBCol lg='7' md='12' className='mb-4 mb-md-0'>
//                   <div className='registerForm'>
//                     <div className='formApply'>
//                       <Form noValidate validated={validated} onSubmit={handleSubmit}>
//                         <Form.Group className="mb-4" as={Col} controlId="validationCustom01">
//                           <Form.Control
//                             required
//                             type="text"
//                             placeholder="Name"
//                             name="first_name"
//                             value={formData.first_name}
//                             onChange={handleChange}
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             Please write your name.
//                           </Form.Control.Feedback>
//                           <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
//                         </Form.Group>

//                         <Form.Group className="mb-4" as={Col} controlId="validationCustomUsername">
//                           <InputGroup hasValidation>
//                             <InputGroup.Text id="inputGroupPrepend">@</InputGroup.Text>
//                             <Form.Control
//                               type="email"
//                               placeholder="Email"
//                               aria-describedby="inputGroupPrepend"
//                               required
//                               name="email_id"
//                               value={formData.email_id}
//                               onChange={handleChange}
//                             />
//                             <Form.Control.Feedback type="invalid">
//                               Please provide a valid email.
//                             </Form.Control.Feedback>
//                             <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
//                           </InputGroup>
//                         </Form.Group>

//                         <Form.Group className="mb-4" as={Col} controlId="message">
//                           <InputGroup hasValidation>
//                             <Form.Control
//                               as="textarea"
//                               rows={3}
//                               type="text"
//                               placeholder="Message"
//                               aria-describedby="inputGroupPrepend"
//                               name="message"
//                               required
//                               value={formData.message}
//                               onChange={handleChange}
//                             />
//                             <Form.Control.Feedback type="invalid">
//                               Please write a message.
//                             </Form.Control.Feedback>
//                             <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
//                           </InputGroup>
//                         </Form.Group>

//                         <Form.Group className="mb-3 d-flex justify-content-end" controlId="checkBox1" style={{ color: "white" }}>
//                           <ReCAPTCHA
//                             sitekey='6LdT26woAAAAABg64esaHXXxC8E2BoRtrhl_0mOV'
//                             // sitekey='6Le0MU8oAAAAAM4zQ8AMbN6ylaqWJP8w-3MwrqMA' no quitar esta linea de codigo
//                             onChange={handleRecaptchaChange}
//                             ref={recaptchaRef}
//                           />
//                         </Form.Group>

//                         <div className='btnForm' style={{ display: 'flex', justifyContent: 'flex-end' }}>
//                           <Button id="btn" type="submit">Send</Button>
//                         </div>
//                       </Form>

//                       {/* ✅ Mensaje de confirmación */}
//                       {showSuccess && (
//                         <div
//                           className="alert alert-success mt-4"
//                           role="alert"
//                           style={{ textAlign: 'center', fontSize: '18px' }}
//                         >
//                           Thanks for getting in touch! We'll get back to you soon.
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </MDBCol>
//               </MDBRow>
//             </MDBContainer>
//           </MDBFooter>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Contact;



import React, { useState, useRef } from 'react';
import { MDBFooter, MDBContainer, MDBCol, MDBRow } from 'mdb-react-ui-kit';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
import emailjs from 'emailjs-com';
import ReCAPTCHA from "react-google-recaptcha";

export const Contact = () => {

  const [formData, setFormData] = useState({
    first_name: '',
    email_id: '',
    message: '',
  });

  const [recaptchaValue, setRecaptchaValue] = useState(null);
  const [showSuccess, setShowSuccess] = useState(false);
  const [validated, setValidated] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const recaptchaRef = useRef(null);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleRecaptchaChange = (value) => {
    setRecaptchaValue(value);
  };





  const handleSubmit = (e) => {
  e.preventDefault();

  if (isSubmitting) return;

  const form = e.currentTarget;
  setValidated(true);

  // ❌ VALIDACIÓN
  if (form.checkValidity() === false) {
    console.log("Form invalid");
    return;
  }

  if (!recaptchaValue) {
    console.log("Missing reCAPTCHA");
    return;
  }

  setIsSubmitting(true);

  const serviceId = 'service_up7eara';
  const templateId = 'template_r446xxq';
  const userId = '4S9SBuGXNl2oJO-Xa';

  console.log("Sending email...");

  emailjs.send(serviceId, templateId, formData, userId)
    .then((response) => {
      console.log("Email sent:", response);

      // reset form
      setFormData({
        first_name: '',
        email_id: '',
        message: '',
      });

      // reset captcha
      setRecaptchaValue(null);
      recaptchaRef.current?.reset();

      // show success
      setShowSuccess(true);

      setTimeout(() => {
        setShowSuccess(false);
      }, 5000);
    })
    .catch((error) => {
      console.error("Email error:", error);
    })
    .finally(() => {
      setIsSubmitting(false);
    });
};




  return (
    <div className='contact' id="Contact">

      <div className='Contact-container'>

        <h1 className='contact-title'>CONTACT US</h1>

        <div className='contact-txt'>
          <p>
            Please don't hesitate to send us a message if you have any questions.
          </p>
        </div>

        <MDBFooter className='text-body text-center text-lg-left'>
          <MDBContainer className='p-4' style={{ maxWidth: '700px' }}>
            <MDBRow>

              <MDBCol lg='5'>
                <h4>Email to us</h4>
                <h6>info@kranestation.co.nz</h6>
              </MDBCol>

              <MDBCol lg='7'>

                <Form noValidate validated={validated} onSubmit={handleSubmit}>

                  {/* NAME */}
                  <Form.Group className="mb-3">
                    <Form.Control
                      required
                      type="text"
                      placeholder="Name"
                      name="first_name"
                      value={formData.first_name}
                      onChange={handleChange}
                    />
                  </Form.Group>

                  {/* EMAIL */}
                  <Form.Group className="mb-3">
                    <InputGroup>
                      <InputGroup.Text>@</InputGroup.Text>
                      <Form.Control
                        required
                        type="email"
                        placeholder="Email"
                        name="email_id"
                        value={formData.email_id}
                        onChange={handleChange}
                      />
                    </InputGroup>
                  </Form.Group>

                  {/* MESSAGE */}
                  <Form.Group className="mb-3">
                    <Form.Control
                      as="textarea"
                      rows={3}
                      placeholder="Message"
                      required
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                    />
                  </Form.Group>

                  {/* CAPTCHA */}
                  <div className="d-flex justify-content-end mb-3">
                    <ReCAPTCHA
                      // sitekey='6Le0MU8oAAAAAM4zQ8AMbN6ylaqWJP8w-3MwrqMA'
                      sitekey='6LdT26woAAAAABg64esaHXXxC8E2BoRtrhl_0mOV'
                      onChange={handleRecaptchaChange}
                      ref={recaptchaRef}
                    />
                  </div>

                  {/* ✅ SUCCESS MESSAGE (ARRIBA DEL BOTÓN) */}
                  {showSuccess && (
                    <div className="alert alert-success text-center mb-3">
                      Thanks for getting in touch! We'll get back to you soon.
                    </div>
                  )}

                  {/* BUTTON */}
                  <div className='d-flex justify-content-end'>
                  <Button type="submit" disabled={isSubmitting}>
                  {isSubmitting ? 'Sending...' : 'Send'}
                  </Button>
                  </div>

                </Form>

              </MDBCol>

            </MDBRow>
          </MDBContainer>
        </MDBFooter>

      </div>

    </div>
  );
};

export default Contact;


      